var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1736240280522,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 24383,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512.38016 0c25.6 0 51.2 4.266667 70.4 14.933333l411.733333 209.066667c38.4 19.2 38.4 51.2 0 72.533333l-409.6 209.066667c-19.2 10.666667-44.8 14.933333-70.4 14.933333-25.6 0-51.2-4.266667-70.4-14.933333L32.38016 296.533333c-38.4-19.2-38.4-51.2 0-72.533333L441.98016 14.933333C461.18016 4.266667 486.78016 0 512.38016 0z m0 774.4c-32 0-61.866667-6.4-87.466667-19.2L21.713493 550.4c-19.2-10.666667-27.733333-34.133333-17.066666-53.333333 10.666667-19.2 34.133333-27.733333 53.333333-17.066667l401.066667 204.8c27.733333 14.933333 78.933333 14.933333 106.666666 0l401.066667-204.8c19.2-10.666667 42.666667-2.133333 53.333333 17.066667s2.133333 44.8-17.066666 53.333333l-403.2 204.8c-27.733333 14.933333-57.6 21.333333-87.466667 19.2zM512.38016 1024c-32 0-61.866667-6.4-87.466667-19.2L21.713493 800C2.513493 789.333333-6.01984 765.866667 4.646827 746.666667c10.666667-19.2 34.133333-27.733333 53.333333-17.066667l401.066667 204.8c27.733333 14.933333 78.933333 14.933333 106.666666 0l401.066667-204.8c19.2-10.666667 42.666667-2.133333 53.333333 17.066667s2.133333 44.8-17.066666 53.333333l-403.2 204.8c-23.466667 12.8-55.466667 19.2-87.466667 19.2z",
    "p-id": 24384,
    fill: "#46766a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/模型介绍.61844094e3c22c6f0f6d7fa58a1c3b05.svg";
export { ForwardRef as ReactComponent };